/** EllipsisTooltip adds an ellipsis with tooltip if its child has overflowing text.
    The tooltip contains the entirety of the text
*/

import React, { useEffect, useRef, useState, Fragment } from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

const StyledWrapper = styled.span`
  vertical-align: middle;
  & > * {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export function EllipsisTooltip({ id, children }) {
  const textWrapperRef = useRef(null);
  const [textOverflowing, setTextOverflowing] = useState(false);
  const [implicitContent, setImplicitContent] = useState('');

  useEffect(() => {
    if (textWrapperRef && textWrapperRef.current) {
      const { current } = textWrapperRef;

      if (current.children.length !== 1) {
        throw new Error(
          "EllipsisTooltip must have one child and the child must be a block level element b/c inline elements don't have meaningful widths"
        );
      }

      const child = current.children[0];
      const { scrollWidth, offsetWidth, textContent } = child;

      setImplicitContent(textContent);
      setTextOverflowing(scrollWidth > offsetWidth);
    }
  }, [textOverflowing, children]);

  const tooltipId = id || String(Number(new Date()));

  return (
    <Fragment>
      <ReactTooltip
        id={tooltipId}
        place="top"
        effect="solid"
        multiline
        clickable
        className="info-tooltip"
        getContent={() => children}
        disable={!textOverflowing}
      />
      <StyledWrapper
        tabIndex="0"
        ref={textWrapperRef}
        data-tip
        data-for={tooltipId}
      >
        {children}
      </StyledWrapper>
    </Fragment>
  );
}
